import * as actionTypes from '../actions/actionTypes'

const initialState = {
    records: [],
    pagination: {
        total: 0,
        perPage: 10,
        currentPage: 0,
        lastPage: 0,
        from: 0,
        to: 0
    },
    appraisalTypes: [],
    filtered: false,
    filterLoading: [],
    filterCompanies: [],
    filterForms: [],
    filterFrgs: [],
    filterData: [],
    gradeData: [],
    filterLoadingQueue: [],
    loading: false,
    data: [],
    total: null,
    adjustData: [],
    unData: [],
    calData: [],
    success: false
}

// FETCH_APPRAISAL_TYPE_OPTION

// START
const fetchAppraisalTypeOptionsStart = (state, action) => {
    return {
        ...state
    }
}

// SUCCESS
const fetchAppraisalTypeOptionsSuccess = (state, action) => {
    return {
        ...state,
        appraisalTypes: action.data.map(item => {
            return {
                appraisal_type_id: item.value_list_id,
                appraisal_type_code: item.value_list_code,
                appraisal_type_name: item.value_list_name
            }
        })
    }
}

// FAILED
const fetchAppraisalTypeOptionsFailed = (state, action) => {
    return {
        ...state
    }
}

// FETCH_COMPANY_OPTION

// START
const fetchCompanyOptionsStart = (state, action) => {
    return {
        ...state,
        filterLoadingQueue: [...state.filterLoadingQueue, 'company_id']
    }
}

// SUCCESS
const fetchCompanyOptionsSuccess = (state, action) => {
    return {
        ...state,
        filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company_id'),
        filterCompanies: action.data
    }
}

// FAILED
const fetchCompanyOptionsFailed = (state, action) => {
    return {
        ...state,
        filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'company_id')
    }
}

// FETCH_FORM_OPTION

// START
const fetchFormOptionsStart = (state, action) => {
    return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'form_id'] }
}

// SUCCESS
const fetchFormOptionsSuccess = (state, action) => {
    return {
        ...state,
        filterForms: action.data,
        filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'form_id')
    }
}

// FAILED
const fetchFormOptionsFailed = (state, action) => {
    return {
        ...state,
        filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'form_id')
    }
}

// // FETCH_ORGANIZATION_OPTION

// START
const fetchForceRankGroupOptionsStart = (state, action) => {
    return { ...state, filterLoadingQueue: [...state.filterLoadingQueue, 'fr_group_id'] }
}

// SUCCESS
const fetchForceRankGroupOptionsSuccess = (state, action) => {
    return {
        ...state,
        filterFrgs: action.data,
        filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'fr_group_id')
    }
}

// FAILED
const fetchForceRankGroupOptionsFailed = (state, action) => {
    return {
        ...state,
        filterLoadingQueue: state.filterLoadingQueue.filter(item => item !== 'fr_group_id')
    }
}

const fetchVerticalForceRankGradeStart = (state, action) => {
    return {
        ...state,
        filtered: true
    }
}

const fetchVerticalForceRankGradeSuccess = (state, action) => {
    return {
        ...state,
        gradeData: action.data
    }
}

const fetchVerticalForceRankGradeFailed = (state, action) => {
    return {
        ...state,
        filtered: false,
        message: action.errorMessage
    }
}

const fetchVerticalForceRankListStart = (state, action) => {
    return {
        ...state,
        loading: true
    }
}

const fetchVerticalForceRankListSuccess = (state, action) => {
    return {
        ...state,
        loading: false,
        data: action.data
    }
}

const fetchVerticalForceRankListFailed = (state, action) => {
    return {
        ...state,
        loading: false,
        message: action.errorMessage
    }
}

const fetchVerticalForceRankCalculateStart = (state, action) => {
    return {
        ...state,
        // loading: true
    }
}

const fetchVerticalForceRankCalculateSuccess = (state, action) => {
    return {
        ...state,
        // loading: false,
        // success: true,
        calData: action.data.adjust
    }
}

const fetchVerticalForceRankCalculateFailed = (state, action) => {
    return {
        ...state,
        // loading: false,
        // success: false,
        message: action.errorMessage
    }
}

const createVerticalForceRankStart = (state, action) => {
    return {
        ...state,
        loading: true
    }
}

const createVerticalForceRankSuccess = (state, action) => {
    return {
        ...state,
        loading: false,
        success: true
    }
}

const createVerticalForceRankFailed = (state, action) => {
    return {
        ...state,
        loading: false,
        success: false
    }
}

const fetchVerticalForceRankStart = (state, action) => {
    return {
        ...state,
        filtered: true,
        filterLoading: true
    }
}

const fetchVerticalForceRankSuccess = (state, action) => {

    return {
        ...state,
        filtered: true,
        filterLoading: false,
        total: action.data.total_amount,
        gradeData: action.data.grade_table,
        adjustData: action.data
    }
}

const fetchVerticalForceRankFailed = (state, action) => {
    return {
        ...state,
        filtered: false,
        filterLoading: false,
        message: action.errorMessage
    }
}

// REDUCER
const reducer = (state = initialState, action) => {
    switch (action.type) {
        // FETCH_APPRAISAL_TYPE_OPTION
        case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
            return fetchAppraisalTypeOptionsStart(state, action)
        case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
            return fetchAppraisalTypeOptionsSuccess(state, action)
        case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
            return fetchAppraisalTypeOptionsFailed(state, action)

        // FETCH_COMPANY_OPTIONS
        case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START:
            return fetchCompanyOptionsStart(state, action)
        case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS:
            return fetchCompanyOptionsSuccess(state, action)
        case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED:
            return fetchCompanyOptionsFailed(state, action)

        // FETCH_FORM_OPTIONS
        case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START:
            return fetchFormOptionsStart(state, action)
        case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS:
            return fetchFormOptionsSuccess(state, action)
        case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED:
            return fetchFormOptionsFailed(state, action)

        // FETCH_FORCE_RANK_GROUP_OPTIONS
        case actionTypes.FETCH_FORCE_RANK_GROUP_OPTIONS_START:
            return fetchForceRankGroupOptionsStart(state, action)
        case actionTypes.FETCH_FORCE_RANK_GROUP_OPTIONS_SUCCESS:
            return fetchForceRankGroupOptionsSuccess(state, action)
        case actionTypes.FETCH_FORCE_RANK_GROUP_OPTIONS_FAILED:
            return fetchForceRankGroupOptionsFailed(state, action)

        // FETCH_VERTICAL_FORCERANK_GRADE
        case actionTypes.FETCH_VERTICAL_FORCERANK_GRADE_START:
            return fetchVerticalForceRankGradeStart(state, action)
        case actionTypes.FETCH_VERTICAL_FORCERANK_GRADE_SUCCESS:
            return fetchVerticalForceRankGradeSuccess(state, action)
        case actionTypes.FETCH_VERTICAL_FORCERANK_GRADE_FAILED:
            return fetchVerticalForceRankGradeFailed(state, action)

        // FETCH_VERTICAL_FORCERANK_LIST
        case actionTypes.FETCH_VERTICAL_FORCERANK_LIST_START:
            return fetchVerticalForceRankListStart(state, action)
        case actionTypes.FETCH_VERTICAL_FORCERANK_LIST_SUCCESS:
            return fetchVerticalForceRankListSuccess(state, action)
        case actionTypes.FETCH_VERTICAL_FORCERANK_LIST_FAILED:
            return fetchVerticalForceRankListFailed(state, action)

        // FETCH_VERTICAL_FORCERANK_LIST
        case actionTypes.FETCH_VERTICAL_FORCERANK_CALCULATE_START:
            return fetchVerticalForceRankCalculateStart(state, action)
        case actionTypes.FETCH_VERTICAL_FORCERANK_CALCULATE_SUCCESS:
            return fetchVerticalForceRankCalculateSuccess(state, action)
        case actionTypes.FETCH_VERTICAL_FORCERANK_CALCULATE_FAILED:
            return fetchVerticalForceRankCalculateFailed(state, action)

        case actionTypes.CREATE_VERTICAL_FORCERANK_START:
            return createVerticalForceRankStart(state, action)
        case actionTypes.CREATE_VERTICAL_FORCERANK_SUCCESS:
            return createVerticalForceRankSuccess(state, action)
        case actionTypes.CREATE_VERTICAL_FORCERANK_FAILED:
            return createVerticalForceRankFailed(state, action)

        // FETCH_ADJUST
        case actionTypes.FETCH_VERTICAL_FORCERANK_START:
            return fetchVerticalForceRankStart(state, action)
        case actionTypes.FETCH_VERTICAL_FORCERANK_SUCCESS:
            return fetchVerticalForceRankSuccess(state, action)
        case actionTypes.FETCH_VERTICAL_FORCERANK_FAILED:
            return fetchVerticalForceRankFailed(state, action)

        // DEFAULT
        default:
            return state
    }
}

export default reducer
